// extracted by mini-css-extract-plugin
module.exports = {"spinner":"ChatItems_spinner__ovQKA","scrollAnchor":"ChatItems_scrollAnchor__MNGPu"};